import { firebase } from './../tools/tools';

export class GenericModel{

  constructor(){}

/***********************************
* Busca el elemento en el arreglo especificado
************************************/
  searchInArray(nameArray, nameKey, myArray){
   for (var i=0; i < myArray.length; i++) {
       if (myArray[i][nameArray] === nameKey) {
           return myArray[i];
       }
   }
 }

 /***********************************
 * Sube al servidor de firebase la imagén especificada
 ************************************/

 uploadImageProfile(file : File, path, name) {
   var fecha = new Date().toISOString();
   return new Promise<any>( (resolve, reject ) => {

     var metadata = {
         'contentType': file.type
     };

     name = name + '-' +fecha;
     var storageRef = firebase.storage().ref();
     storageRef.child(path + `/${name}`).put(file, metadata).then( (snapshot) => {
         var url = snapshot.ref.getDownloadURL();
         resolve(url)
     }).catch(function(error) {
         console.log(error)
     });

   });
 }
}
